import script from "./SafeServiceBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SafeServiceBar.vue?vue&type=script&setup=true&lang=js"

import "./SafeServiceBar.vue?vue&type=style&index=0&id=a7e4e022&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7e4e022"]])

export default __exports__